export const networkConnectFail = 'message.networkConnectFail';
export const messageArray = new Map([
  ['PLATFORM-COMMON-00001-400', 'errorCode.invalidQueryParameterValue'],
  ['PLATFORM-COMMON-00002-400', 'errorCode.invalidHeaderValue'],
  ['PLATFORM-COMMON-00003-400', 'errorCode.invalidInput'],
  ['PLATFORM-COMMON-00004-401', 'errorCode.unauthorized'],
  ['PLATFORM-COMMON-00005-401', 'errorCode.invalidIdToken'],
  ['PLATFORM-COMMON-00006-403', 'errorCode.invalidResource'],
  ['PLATFORM-COMMON-00007-403', 'errorCode.invalidProject'],
  ['PLATFORM-COMMON-00008-403', 'errorCode.accessDenied'],
  ['PLATFORM-COMMON-00009-404', 'errorCode.resourceNotFound'],
  ['PLATFORM-COMMON-00010-404', 'errorCode.apiNotFound'],
  ['PLATFORM-COMMON-00011-404', 'errorCode.apiGroupFound'],
  ['PLATFORM-COMMON-00012-409', 'errorCode.resourceAlreadyExists'],
  ['PLATFORM-COMMON-00013-409', 'errorCode.dataConflicted'],
  ['PLATFORM-COMMON-00014-500', 'errorCode.apiConnectionError'],
  ['PLATFORM-COMMON-00015-500', 'errorCode.apiInvokeError'],
  ['PLATFORM-COMMON-00016-500', 'errorCode.cmpConfigurationError'],
  ['PLATFORM-COMMON-00017-500', 'errorCode.dataAccessError'],
  ['PLATFORM-COMMON-00018-500', 'errorCode.internalServerError'],
  ['PLATFORM-COMMON-00019-401', 'errorCode.sessionExpired'],
  ['PLATFORM-COMMON-00021-401', 'errorCode.sessionDuplicated'],
  ['PLATFORM-COMMON-00022-401', 'errorCode.loginRequired'],
  ['PLATFORM-COMMON-00023-500', 'errorCode.roleAlreadyAssigned'],
  ['PLATFORM-COMMON-00024-404', 'errorCode.blockedMethod'],
  ['PLATFORM-COMMON-00025-500', 'errorCode.assumeRoleFailed'],
  ['PLATFORM-COMMON-00026-403', 'errorCode.roleExpired'],
  ['PLATFORM-COMMON-00026-404', 'errorCode.swaggerGroupNotFound'],
  ['PLATFORM-COMMON-00027-404', 'errorCode.commonCodeNotFound'],
  ['PLATFORM-COMMON-00028-404', 'errorCode.commonCodeClassNotFound'],
  ['PLATFORM-COMMON-00029-404', 'errorCode.lowerCommonCodeClassNotFound'],
]);
